import React, { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon } from "@radix-ui/react-icons";
import Checkbox from '../../../../components/checkbox'
import { useDispatch, useSelector } from "react-redux";
import { Additem } from "../../../../Redux/Items/action";
import { useEffect } from "react";
import { unitsmeasure } from "../../../../Redux/Master/action";
import toast from "react-hot-toast";

const DialogDemo = ({ open, setOpen, Editvalue }) => {
  const dispatch = useDispatch()
  const [isTaxInclusive, setisTaxInclusive] = useState(false);
  const [IsRowMaterial, setIsRowMaterial] = useState(false);
  const [name, setName] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [code, setCode] = useState();
  const [price, setPrice] = useState();
  const [Gst, setGst] = useState();
  const [openingstock, setopeningstock] = useState();
  const [openingstockValue, setopeningstockValue] = useState();
  const [reorderlevel, setreorderlevel] = useState();
  const [unit, setunit] = useState();
  
  // New state for confirmation dialog
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [tempModalClosed, setTempModalClosed] = useState(false);
  
  const TempleId = JSON.parse(localStorage.getItem('Sopanam_TempleId'));
  const UserId = JSON.parse(localStorage.getItem('Sopanam_UserId'));
  const unitlist = useSelector((state) => state.Master.unitvalue);
  const [loading, setLoading] = useState(false);
  const [minDate, setMinDate] = useState('');

  useEffect(() => {
    if (Editvalue) {
      setName(Editvalue.Name);
      const editDate = Editvalue.OpenStockDate ? Editvalue.OpenStockDate.split('T')[0] : null;
      setSelectedDate(editDate || new Date().toISOString().split('T')[0]);
      setMinDate(editDate ? editDate : '');
      setCode(Editvalue.Code);
      setPrice(Editvalue.Rate);
      setGst(Editvalue.Tax);
      setunit(Editvalue.UnitId);
      setopeningstock(Editvalue.OpeningStock)
      setreorderlevel(Editvalue.ItemReOrderLevel)
      setopeningstockValue(Editvalue.OpeningStockValue)
      setisTaxInclusive(Editvalue.TaxType == 1 ? true : false);
      setIsRowMaterial(Editvalue.IsRowMaterial == 1 ? true : false);
    } else {
      setMinDate('');
    }
  }, [Editvalue])

  useEffect(() => {
    dispatch(unitsmeasure())
  }, [])

  // Handle save button click - show confirmation
  const handleSaveClick = () => {
    setTempModalClosed(true);  // Temporarily close main modal
    setShowConfirmation(true); // Show confirmation dialog
  };

  // Handle confirmation Yes
  const handleConfirmYes = () => {
    setShowConfirmation(false);
    setTempModalClosed(false);
    
    // Perform the actual save operation
    if (Editvalue) {
      const Nameslipt = name.split(/[\[\]]/).filter(Boolean);
      dispatch(Additem({
        Id: Editvalue.Id,
        Name: Nameslipt[0],
        OpenStockDate: selectedDate,
        Code: code,
        Barcode: "",
        UserId: UserId,
        Rate: price,
        HSNCode: "",
        Tax: Gst,
        Cess: 0,
        Unit: "",
        UOM: unit,
        OpeningStock: openingstock,
        OpeningStockValue: openingstockValue,
        ReOrderLevel: reorderlevel,
        TaxType: isTaxInclusive ? 1 : 0,
        IsRowMaterial: IsRowMaterial ? 1 : 0,
        TempleId: TempleId,
        ItemRates: [
          {
            PriceGroupId: 1,
            Rate: price
          }
        ]
      }));
    } else {
      if (name && price && openingstock && reorderlevel && openingstockValue && unit) {
        dispatch(Additem({
          Id: 0,
          Name: name,
          OpenStockDate: selectedDate,
          Code: code,
          Barcode: "",
          UserId: UserId,
          Rate: price,
          HSNCode: "",
          Tax: Gst,
          Cess: 0,
          Unit: "",
          UOM: unit,
          OpeningStock: openingstock,
          OpeningStockValue: openingstockValue,
          ReOrderLevel: reorderlevel,
          TaxType: isTaxInclusive ? 1 : 0,
          IsRowMaterial: IsRowMaterial ? 1 : 0,
          TempleId: TempleId,
          ItemRates: [
            {
              PriceGroupId: 1,
              Rate: price
            }
          ]
        }));
      } else {
        toast.error("Fill all the mandatory fields");
      }
    }
    
    // Close the main modal after successful save
    setOpen(false);
  };

  // Handle confirmation Cancel
  const handleConfirmCancel = () => {
    setShowConfirmation(false);
    setTempModalClosed(false); // Reopen main modal
  };

  // Custom Confirmation Dialog Component
  const ConfirmationDialog = () => (
    <Dialog.Root open={showConfirmation} onOpenChange={setShowConfirmation}>
      <Dialog.Portal>
        <Dialog.Overlay className="data-[state=open]:animate-overlayShow fixed inset-0 bg-blackA6 z-[100]" />
        <Dialog.Content className="data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] z-[101] max-h-[85vh] w-full max-w-[450px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none">
          <Dialog.Title className="m-0 mb-4 text-[17px] font-medium text-mauve12">
            Confirm Save Item
          </Dialog.Title>
          
          <div className="mb-6">
            <p className="text-[15px] text-mauve12 mb-4">
              Please confirm the following details:
            </p>
            
            <div className="bg-gray-50 p-4 rounded-lg space-y-3">
              <div className="flex justify-between">
                <span className="font-medium text-gray-700">Opening Stock:</span>
                <span className="text-gray-900">{openingstock || 'Not provided'}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium text-gray-700">Opening Stock Value:</span>
                <span className="text-gray-900">{openingstockValue || 'Not provided'}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium text-gray-700">Opening Stock Date:</span>
                <span className="text-gray-900">{selectedDate || 'Not provided'}</span>
              </div>
            </div>
          </div>
          
          <div className="flex justify-end gap-3">
            <button
              className="inline-flex h-[35px] items-center justify-center rounded-[4px] bg-gray-200 px-[15px] font-medium leading-none text-gray-700 hover:bg-gray-300 focus:shadow-[0_0_0_2px] focus:shadow-gray-400 focus:outline-none"
              onClick={handleConfirmCancel}
            >
              Cancel
            </button>
            <button
              className="inline-flex h-[35px] items-center justify-center rounded-[4px] bg-green-500 px-[15px] font-medium leading-none text-white hover:bg-green-600 focus:shadow-[0_0_0_2px] focus:shadow-green-700 focus:outline-none"
              onClick={handleConfirmYes}
            >
              Yes, Save
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );

  return (
    <>
      {/* Main Dialog */}
      <Dialog.Root open={open && !tempModalClosed} onOpenChange={setOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="data-[state=open]:animate-overlayShow fixed inset-0 bg-blackA6 " />
          <Dialog.Content className="data-[state=open]:animate-contentShow md: md: fixed top-[50%] left-[50%] z-50 max-h-[85vh] w-full max-w-[600px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none">
            <Dialog.Title className="m-0 mb-4 flex text-[17px] font-medium text-mauve12">
              Insert Item
            </Dialog.Title>

            <div className="mb-[15px] flex items-center gap-4">
              <div className="flex-1">
                <label className="block text-[15px] text-mauve12" htmlFor="name">
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  className="h-[35px] w-full rounded-[4px] px-[10px] text-[15px] shadow-[0_0_0_1px] shadow-mauve12 outline-none focus:shadow-[0_0_0_2px] focus:shadow-violet8"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="flex-1">
                <label className="block text-[15px] text-mauve12" htmlFor="date">
                  Opening Stock Date
                </label>
                <input
                  type="date"
                  id="date"
                  value={selectedDate}
                  min={minDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="h-[35px] w-full rounded-[4px] px-[10px] text-[15px] shadow-[0_0_0_1px] shadow-mauve12 outline-none focus:shadow-[0_0_0_2px] focus:shadow-violet8"
                />
              </div>
            </div>

            <div className=" flex justify-around">
              <div className="mb-[15px] flex-1 items-center gap-5">
                <label
                  className="w-[90px] flex-1 text-right text-[15px] text-mauve12"
                  htmlFor="code"
                >
                  Code
                </label>
                <input
                  className="inline-flex h-[35px] w-[250px] flex-1 flex-1 items-center justify-center rounded-[4px] px-[10px] text-[15px] leading-none text-mauve12 shadow-[0_0_0_1px] shadow-mauve12 outline-none focus:shadow-[0_0_0_2px] focus:shadow-violet8"
                  id="code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />
              </div>
              <div className="mb-[15px] flex-1 items-center gap-5">
                <label
                  className="w-[90px] text-right text-[15px] text-mauve12"
                  htmlFor="price"
                >
                  Price <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  className="inline-flex h-[35px] w-full flex-1 items-center justify-center rounded-[4px] px-[10px] text-[15px] leading-none text-mauve12 shadow-[0_0_0_1px] shadow-mauve12 outline-none focus:shadow-[0_0_0_2px] focus:shadow-violet8"
                  id="price"
                  onWheel={(e) => e.target.blur()}
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>
            </div>

            <div className=" flex justify-around">
              <div className="mb-[15px] flex-1 items-center gap-5">
                <label
                  className="w-[90px] flex-1 text-right text-[15px] text-mauve12"
                  htmlFor="gst"
                >
                  Opening Stock <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  className="inline-flex h-[35px] w-[250px] flex-1 flex-1 items-center justify-center rounded-[4px] px-[10px] text-[15px] leading-none text-mauve12 shadow-[0_0_0_1px] shadow-mauve12 outline-none focus:shadow-[0_0_0_2px] focus:shadow-violet8"
                  id="gst"
                  value={openingstock}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setopeningstock(e.target.value)}
                />
              </div>
              <div className="mb-[15px] flex-1 items-center gap-5">
                <label
                  className="w-[90px] text-right text-[15px] text-mauve12"
                  htmlFor="price"
                >
                  Opening Stock Value <span className="text-red-500">*</span>
                </label>
                <input
                  className="inline-flex h-[35px] w-[250px] flex-1 flex-1 items-center justify-center rounded-[4px] px-[10px] text-[15px] leading-none text-mauve12 shadow-[0_0_0_1px] shadow-mauve12 outline-none focus:shadow-[0_0_0_2px] focus:shadow-violet8"
                  id="gst"
                  type='number'
                  value={openingstockValue}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setopeningstockValue(e.target.value)}
                />
              </div>
            </div>

            <div className=" flex justify-around">
              <div className="mb-[15px] flex-1 items-center gap-5">
                <label
                  className="w-[90px] flex-1 text-right text-[15px] text-mauve12"
                  htmlFor="gst"
                >
                  Reorder Level <span className="text-red-500">*</span>
                </label>
                <input
                  className="inline-flex h-[35px] w-[250px] flex-1 flex-1 items-center justify-center rounded-[4px] px-[10px] text-[15px] leading-none text-mauve12 shadow-[0_0_0_1px] shadow-mauve12 outline-none focus:shadow-[0_0_0_2px] focus:shadow-violet8"
                  id="gst"
                  value={reorderlevel}
                  onChange={(e) => setreorderlevel(e.target.value)}
                />
              </div>
              <div className="mb-[15px] flex-1 items-center gap-5">
                <label
                  className="w-[90px] text-right text-[15px] text-mauve12"
                  htmlFor="price"
                >
                  Unit<span className="text-red-500">*</span>
                </label>
                <select
                  className="block w-full rounded-lg border border-green-500 border-gray-700 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
                  id="party"
                  value={unit}
                  onChange={(e) => setunit(e.target.value)}
                >
                  <option value="">Select Unit</option>
                  {Array.isArray(unitlist) &&
                    unitlist.length > 0 &&
                    unitlist.map((unit) => (
                      <option key={unit.Id} value={unit.Id}>
                        {unit.Name}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="flex mt-3 mb-3">
              {/* Commented out checkboxes as in original */}
            </div>

            <div className="mt-[25px] flex justify-end">
              <button
                className="inline-flex h-[35px] items-center justify-center rounded-[4px] bg-green4 px-[15px] font-medium leading-none text-green11 hover:bg-green5 focus:shadow-[0_0_0_2px] focus:shadow-green7 focus:outline-none"
                onClick={handleSaveClick}
              >
                Save Item
              </button>
            </div>

            <Dialog.Close asChild>
              <button
                className="absolute top-[10px] right-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full text-mauve12 hover:bg-violet4 focus:shadow-[0_0_0_2px] focus:shadow-mauve12 focus:outline-none"
                aria-label="Close"
              >
                <Cross2Icon />
              </button>
            </Dialog.Close>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>

      {/* Confirmation Dialog */}
      <ConfirmationDialog />
    </>
  );
};

export default DialogDemo;